import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ProductMovementService } from 'app/services/models/product-movement.service';
import { ProductService } from 'app/services/models/product.service';
import { WarehouseService } from 'app/services/models/warehouse.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-product-movement-create',
  templateUrl: './product-movement-create.component.html',
  styleUrls: ['./product-movement-create.component.scss']
})
export class ProductMovementCreateComponent implements OnInit {
  form: FormGroup;
  @Input() data: {productId:number,productMovement?:any};
  public warehouse = [];
  public count: number = 1;

  constructor(
    public ngbModal: NgbActiveModal,
    private productMovementService: ProductMovementService,
    private toastrService: ToastrService,
    private productService: ProductService,
    private warehouseService: WarehouseService,
    private fb: FormBuilder) {
    this.form = this.fb.group({
      warehouseId: [null, Validators.required],
      count: [null, Validators.required]
    });
  }

  async ngOnInit() {
    console.log(this.data);
    if(this.data.productMovement){
      this.form.patchValue({
        warehouseId:this.data.productMovement.warehouseId,
        count:this.data.productMovement.productCount
      })
    }
    await this.getAllWarehouse(0, 100, '');
  }

  async getAllWarehouse(page, size, search) {
    const data = await this.warehouseService.getAllWarehouses(page, size, search);
    console.log(data);
    this.warehouse = data.warehouses;
  }

  closeModal() {
    this.ngbModal.close('Modal Kapatıldı.');
  }

  async createProductSerial() {
    if (this.form.valid) {

      const { warehouseId, count } = this.form.value;
      if(this.data.productMovement != null){
        const data = await this.productMovementService.updateProductMovement(this.data.productMovement.id,count,warehouseId)
        if(data.status == true){
          this.productService.sendEvent(true);
          this.toastrService.success(data.message,"Hareket Güncelleme");
          this.closeModal();
        }else{
          this.toastrService.error(data.message,"Hareket Güncelleme.");
        }
      }else{
        const data = await this.productMovementService.createProductMovement(count,this.data.productId,warehouseId)
        if(data.status == true){
          this.productService.sendEvent(true);
          this.toastrService.success(data.message,"Hareket Oluşturma");
          this.closeModal();
        }else{
          this.toastrService.error(data.message,"Hareket Oluşturulamadı.");
        }
      }
      
    }
  }

}
